/**
 * Private modules
 */
const {
  customerId,
  objectId,
  percent,
  rootId,
} = require('../.private').components;

module.exports = {
  updateCustomerRunnerContractDiscountsByRootId: {
    properties: {
      body: {
        properties: {
          discounts: {
            items: {
              properties: {
                objectId,
                percent,
              },
              required: [
                'objectId',
                'percent',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: ['discounts'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          rootId,
        },
        required: [
          'customerId',
          'rootId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
